import React, { useContext } from 'react';
import { MenuDropdownItem } from '@instinet-analytics/semantic-ui-components';
import AppContext from 'app/AppContext';
import { DropdownTooltip } from '@instinet-analytics/semantic-ui-components';
import { useTilesConfigSlice } from 'widgets/tiles/store/config/configSlice';
import { WidgetType } from 'widgets/WidgetType';
import './AddCapsuleDropdown.scss';
import { useCategorisedWidgets } from 'widgets/hooks';
import { WidgetDropdownCategory } from 'widgets/WidgetCategory';
import { WidgetDropdownItem } from 'widgets/WidgetsService';
import { useServices } from 'app/hooks.ts';

export interface AddCapsuleMenuItemsProps {
    categories: WidgetDropdownCategory[];
    searchText: string;
    onClick: () => void;
}
export default function AddCapsuleMenuItems(props: AddCapsuleMenuItemsProps) {
    const { clickstreamService, loggingService } = useServices();

    const { categories, searchText, onClick } = props;
    const {
        config: { tiles },
        dispatchConfigChanged,
    } = useTilesConfigSlice();

    const {
        services: { widgetsService },
    } = useContext(AppContext);

    const categorisedWidgets = useCategorisedWidgets('tile', categories);

    const dispatchRequestAddWidget = (widgetType: WidgetType) => {
        const componentId = widgetsService.getNextWidgetId(widgetType);

        const nextTiles = [...tiles, { widgetType, widgetKey: componentId }];
        dispatchConfigChanged({ tiles: nextTiles });

        loggingService.debug(
            'AddCapsuleMenuItems',
            'Recording adding capsule',
            widgetType
        );

        clickstreamService.recordWidgetUsage(widgetType);
        onClick();
    };

    return (
        <div className="column">
            {categorisedWidgets.map((i) => (
                <CategorisedWidget
                    key={i.category.category}
                    category={i.category}
                    options={i.options}
                    searchText={searchText}
                    dispatchRequestAddWidget={dispatchRequestAddWidget}
                />
            ))}
        </div>
    );
}

interface CategorisedWidgetProps {
    category: WidgetDropdownCategory;
    options: WidgetDropdownItem[];
    searchText: string;
    dispatchRequestAddWidget: (widgetType: WidgetType) => void;
}
function CategorisedWidget(props: CategorisedWidgetProps) {
    const { category, searchText, options, dispatchRequestAddWidget } = props;

    const filteredOptions = options.filter(
        (o) =>
            !searchText ||
            o.title.toLowerCase().indexOf(searchText.toLowerCase()) > -1
    );

    if (filteredOptions.length === 0) {
        return <></>;
    }

    return (
        <>
            {category.title !== '' && (
                <div className="title add-capsule-item">{category.title}</div>
            )}
            {filteredOptions.map((o) => (
                <DropdownTooltip text={o.description} key={o.type}>
                    <MenuDropdownItem
                        text={o.title}
                        className={`add-widget-${o.type}`}
                        icon="add"
                        onClick={() => dispatchRequestAddWidget(o.type)}
                    />
                </DropdownTooltip>
            ))}
        </>
    );
}
